import client from "./client";

const dashboardlogin_endpoint = "/api/dashboardlogin";

const dashboardlogin = async (email, pass) => {
  let payload = {
    Email: email,
    Password: pass,
  };
  return client.post(dashboardlogin_endpoint, payload);
};

export default {
  dashboardlogin,
};
